module.exports = __webpack_public_path__ + "static/media/02B.bb70c131.png";